export default __webpack_public_path__ + "static/media/14_photo.a1e4a88b.jpg";